/**
 * Semantic heading with **`qz-heading`** scale.
 *
 * @param level - **`1`** through **`6`**; maps to **`h1`** ... **`h6`**.
 * @param text - Visible text (normally from **`Translate`**).
 * @returns Heading element with **`qz-heading`** and level modifier.
 */
export function createHeading(
  level: 1 | 2 | 3 | 4 | 5 | 6,
  text: string,
): HTMLHeadingElement {
  const tag = `h${level}` as const;
  const el = document.createElement(tag);
  el.textContent = text;
  el.className = `qz-heading qz-heading--${level}`;
  return el;
}
